import { render, staticRenderFns } from "./amsDashboard.vue?vue&type=template&id=369db56c"
import script from "./amsDashboard.vue?vue&type=script&lang=js"
export * from "./amsDashboard.vue?vue&type=script&lang=js"
import style0 from "./amsDashboard.vue?vue&type=style&index=0&id=369db56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports